module.exports = __webpack_public_path__ + "static/media/page404animation.fedf7125.gif";